import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import HeightPin from "../HeightPin";
import ScrollSection from "../ScrollSection";
import GemDiscover from "../elements/GemDiscover";
import MoodBoard from "../MoodBoard"
import ImageCirclePack from "../charts/ImageCirclePack";
import TreeMap from "../charts/TreeMap";
import CardFlip from "../elements/CardFlip";
import FormElement from "../elements/FormElement";
import Results from "../elements/Results";
import SectionTop from "./SectionTop";
import {getAltText, getSectionImage, getInfoClass, getImageInfoStyle} from "../../assets/settings";

function CampusPlanning(props) {
    const {store, state, color, index, downhill} = props;
    const {circlePackStore} = store;

    const group = 'LC';
    const activeKey = store.activeSection(group) || 'LC_2';


    const sectionY = 0.35;

    const backgroundStyle = {
      backgroundImage: `url(img/LC/LC_background.jpg)`
    };

    return (
        <div className={'Section'}>
            <SectionTop group={group} downhill={downhill}>
                  <h4>The planning process is an opportunity to consider how the physical environment can reinforce what is unique about UC Berkeley.</h4>
                  <p>
                    This includes identifying indoor and outdoor spaces that support everyday campus life for the campus community and visitors.
                  </p>
                  <p>
                    The community participates in campus life through attending events, dining with friends and colleagues, participating in student organizations, and more.
                  </p>
                  <p>
                    Good planning and design can help foster a sense of community and belonging.
                  </p>
                  <p className="photocredit">
                    Photo Credit: Peg Skorpinski
                  </p>
            </SectionTop>
            <HeightPin store={store} state={state} scrollChild={<div className={'left-scroll'}>
                <div className={'spacer'} style={{height: 150}}/>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`LC_2`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'LC_2')}>
                        <h4>How does student activity fluctuate over the course of one week?</h4>
                        <p>
                            A core part of campus planning is space assessment, which involves looking at different categories of space across the entire campus.
                        </p>
                        <p>
                            This animation shows where scheduled academic student activity is occurring, and the size of the group, throughout a typical week.
                        </p>
                        <p>
                            The dots show where the activity is happening, by building. The larger the dot, the larger the group. The color of the dot shows different space types (classroom, meeting room, etc).
                        </p>
                        <p>
                          The campus is most active Mondays to Fridays, from 8am – 8pm, with peak activity occurring between 9am and 6pm each day.
                        </p>
                        <p>
                          Students spend the greatest amount of scheduled time in classrooms.
                        </p>
                        <p>
                          Areas that show little activity (i.e. no colored dots) generally indicate a lack of scheduled events, although more informal, non-scheduled activity may be occurring.
                        </p>
                        <p>
                          The visualization is based on the 2018-2019 course schedule.
                        </p>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`LC_3`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'LC_3')}>
                      <h4>
                        What types of additional campus life spaces are needed to improve the campus experience and help build community?
                      </h4>
                      <p>
                        The 2019 LRDP & Campus Master Plan survey asked the campus community to select what additional campus life spaces they wanted on campus.
                      </p>
                      <p>
                        Gathering/hangout space and recreation space were identified as the top two campus life needs on-campus among all respondents, including students, faculty, and staff.
                      </p>
                      <p>
                        Many respondents also noted a desire for more open spaces; and study spaces where food is allowed. See the Long Range Development Plan and Campus Master Plan websites for more information about the survey results.
                      </p>
                      <ul>
                        <li>
                          <a target={'_blank'} href="https://lrdp.berkeley.edu/documents">Long Range Development Plan</a>
                        </li>
                        <li>
                          <a target={'_blank'} href="https://masterplan.berkeley.edu/documents">Campus Master Plan</a>
                        </li>
                      </ul>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`LC_4`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'LC_4')}>
                      <h4>
                        How much space is needed to support campus life?
                      </h4>
                      <p>
                        A space assessment determines space needs relative to campus population projections. The space assessment informs the development program – the types and amount of space for which the Long Range Development Plan and Campus Master Plan will identify locations.
                      </p>
                      <p>
                        Based on the space assessment, there is a need for key campus life spaces, such as lounges and recreation facilities.
                      </p>
                      <p>
                        The Long Range Development Plan and Campus Master Plan present an opportunity to consider where additional spaces may be located on-campus to support community-building, contemplation, and wellness.
                      </p>
                    </div>
                </ScrollSection>

                <div className={'spacer'} style={{height: '50vh'}}/>
            </div>}
                       pinChild={<div className={'sticky-image-right'}>
                           <div className={'frame'}>
                              {getAltText(activeKey).title && <h4 style={{'backgroundColor': color + '80'}}>{getAltText(activeKey).title}</h4>}
                               <img width={'100%'} src={getSectionImage(group, activeKey)}  alt={getAltText(activeKey).alt}/>
                           </div>
                       </div>}
            />
            <div className={'interactive'}>
                <CardFlip color={color} index={111} store={store}
                      frontFace={<FormElement store={store} id={group} />}
                      backFace={<Fragment>
                          <Results store={store} id={group} />
                          {/*<GemDiscover store={store} color={color} index={index}/>*/}

                      </Fragment>}/>
                <div className={'card-pair-spacer'} style={{height: '18px'}}/>
                <CardFlip color={color} index={index} store={store}
                          frontFace={<Fragment>
                            <h3>What kind of collaboration/work space do you prefer?  </h3>
                            <p>Choose up to four images</p>
                            <MoodBoard store={store}/>
                          </Fragment>}
                          backFace={<Fragment>
                              <ImageCirclePack store={store} circles={circlePackStore.packedCircles} width={circlePackStore.width}
                                               height={circlePackStore.height} legendSvg={<g transform={`translate(15,${circlePackStore.height - 110})`}>
                                  <circle cx={15} cy={15} r={10} fill={'none'} strokeWidth={4} stroke={'white'}/>
                                  <text x={40} y={20} fill={'white'}>What you said</text>
                                  <circle cx={15} cy={45} r={10} fill={'#003262'}/>
                                  <text x={40} y={50} fill={'white'}>What others selected</text>
                                  <text x={10} y={80} fontSize={'12px'} fill={'white'}>Larger images have been selected more often</text>
                              </g>}/>
                              {/*<GemDiscover store={store} color={color} index={index}/>*/}

                          </Fragment>}/>

            </div>
        </div>
    );
}

export default observer(CampusPlanning);
